import AuthHealthCheckAPI from '@/app/apis/auth/auth-health-check/auth-health-check-api.js';

export default {
	async getHealthCheck() {
		return AuthHealthCheckAPI.getHealthCheck();
	}
}